import {
  LIST_SERVICES_SINGLE,
  SELECTED_SERVICES_SINGLE,
  PAYMENT_TYPE_SERVICES_SINGLE,
  TOTAL_PRICE_SERVICES_SINGLE,
  SELECTED_SERVICES_FROM_MAP_SINGLE,
  SERVICE_PRICE_SERVICES_SINGLE,
  RESET_STATE_SERVICES_SINGLE
} from "../../Types";

const initialState ={
  listServices: [],
  selectedService: null,
  paymentType: 'online',
  totalPrice: 0,
  servicePrice: 0,
  selectedServicesFromMap: null,
}

export const servicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SERVICES_SINGLE: {
      return {
        ...state,
        listServices: action.payload,
      };
    }
    case SELECTED_SERVICES_SINGLE: {
      return {
        ...state,
        selectedService: action.payload,
      };
    }
    case PAYMENT_TYPE_SERVICES_SINGLE: {
      return {
        ...state,
        paymentType: action.payload,
      };
    }
    case TOTAL_PRICE_SERVICES_SINGLE: {
      return {
        ...state,
        totalPrice: action.payload,
      };
    }
    case SERVICE_PRICE_SERVICES_SINGLE: {
      return {
        ...state,
        servicePrice: action.payload,
      };
    }
    case SELECTED_SERVICES_FROM_MAP_SINGLE: {
      return {
        ...state,
        selectedServicesFromMap: action.payload,
      };
    }
    case RESET_STATE_SERVICES_SINGLE: {
      return initialState;
    }
    default:
      return state;
  }
};
